/* Boudoir theme JS — mobile nav, product gallery, variant swatches, cart qty */

document.addEventListener('DOMContentLoaded', function () {
  // Mobile menu toggle
  var toggle = document.querySelector('.menu-toggle');
  var nav = document.querySelector('.site-nav');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  // Product gallery thumbnails
  var mainImage = document.querySelector('[data-main-image]');
  document.querySelectorAll('[data-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (!mainImage) return;
      mainImage.src = thumb.dataset.thumb;
      mainImage.srcset = '';
      document.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });

  // Variant swatches
  var productForm = document.querySelector('[data-product-form]');
  if (productForm) {
    var variantsData = document.querySelector('[data-variants-json]');
    var variants = variantsData ? JSON.parse(variantsData.textContent) : [];
    var groups = Array.prototype.slice.call(productForm.querySelectorAll('[data-option-group]'));
    var idInput = productForm.querySelector('[name="id"]');
    var priceEl = document.querySelector('[data-product-price]');
    var buyButton = productForm.querySelector('[data-buy-button]');

    function selectedOptions() {
      return groups.map(function (g) {
        var checked = g.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    function currentVariant() {
      var chosen = selectedOptions();
      return variants.find(function (v) {
        return chosen.every(function (val, i) { return val !== null && v.options[i] === val; });
      });
    }

    function moneyFormat(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function updateAvailability() {
      var chosen = selectedOptions();
      groups.forEach(function (group, i) {
        group.querySelectorAll('input').forEach(function (input) {
          var available = variants.some(function (v) {
            if (!v.available) return false;
            if (v.options[i] !== input.value) return false;
            return chosen.every(function (val, idx) {
              return idx === i || val === null || v.options[idx] === val;
            });
          });
          input.closest('.swatch').classList.toggle('is-unavailable', !available);
        });
      });
    }

    function updateVariant() {
      var variant = currentVariant();
      updateAvailability();
      if (!variant) {
        if (buyButton) { buyButton.disabled = true; buyButton.textContent = 'Unavailable'; }
        return;
      }
      idInput.value = variant.id;
      if (priceEl) {
        var html = '';
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          html += '<s>' + moneyFormat(variant.compare_at_price) + '</s>';
        }
        html += '<span>' + moneyFormat(variant.price) + '</span>';
        priceEl.innerHTML = html;
      }
      if (buyButton) {
        var buyLabel = buyButton.dataset.buyLabel || 'Add to bag';
        buyButton.disabled = !variant.available;
        buyButton.textContent = variant.available ? buyLabel : 'Sold out';
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    groups.forEach(function (g) {
      g.addEventListener('change', updateVariant);
    });
    if (groups.length) updateVariant();
  }

  // Cart: auto-submit on quantity change
  document.querySelectorAll('.cart-qty').forEach(function (input) {
    input.addEventListener('change', function () {
      var form = input.closest('form');
      if (form) form.submit();
    });
  });
});
